import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, requiredPermissions }) => {
  const stored = localStorage.getItem("perms");
  const permissions = stored ? stored.split(",").map((p) => p.trim()) : [];

  const hasPermission = requiredPermissions.some((p) =>
    permissions.includes(p)
  );

  return hasPermission ? children : <Navigate to="/not-found" replace />;
};

export default ProtectedRoute;
